<template>
  <div animation="fade" :only-fade="true" class="review-tabs">
    <template v-if="findingsFound.length > 0">
      <div class="divider is-divider-primary" v-translate>Handled findings</div>
      <collapse-component accordion is-fullwidth>
        <collapse-item
          v-for="result in findingsFound"
          ref="collapseItem"
          v-bind="{ itemId: result.id }"
          :key="result.id"
          :title="getCollapseItemTitle(result)">
          <comment-finding-list-component
            :finding="result.finding">
          </comment-finding-list-component>
        </collapse-item>
      </collapse-component>
    </template>
  </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex'
  import CollapseComponent from '@/components/layout/collapse/Collapse'
  import CollapseItem from '@/components/layout/collapse/Item'
  import CommentFindingListComponent from '@/components/layout/utility/CommentFindingListComponent'

  export default {
    name: 'case-review-findings-view',
    data () {
      return {
        is_valid: true
      }
    },
    props: {
      caseId: {
        required: true
      }
    },
    components: {
      CommentFindingListComponent,
      CollapseComponent,
      CollapseItem
    },
    computed: {
      ...mapState({
        reviewResults: state => state.caseReviewModule.reviewResults
      }),
      ...mapGetters([
        'getAllReviewResultFindings'
      ]),
      findingsFound () {
        this.findAndToggleCollapseItem()
        return this.getAllReviewResultFindings
      }
    },
    methods: {
      getCollapseItemTitle (result) {
        let commentCount = result.finding ? result.finding.comments.length + 1 : 0
        return `${result.getLabel()} (${commentCount})`
      },
      getCollapseItemForReviewResult (reviewResultId) {
        return this.$refs.collapseItem && reviewResultId ? this.$refs.collapseItem.find((collapseItem) => {
          return collapseItem.itemId === reviewResultId
        }) : null
      },
      findAndToggleCollapseItem () {
        let reviewResult = this.reviewResults.find((reviewResult) => {
          return reviewResult.triggerToggle
        })
        reviewResult && this.toggleCollapseItem(reviewResult.id)
      },
      toggleCollapseItem (reviewResultId) {
        let collapseItem = this.getCollapseItemForReviewResult(reviewResultId)
        collapseItem && collapseItem.toggle()
      }
    },
    updated () {
      // reset triggeToggle
      this.reviewResults.forEach((reviewResult) => {
        reviewResult.triggerToggle = false
      })
    }
  }
</script>
